import merge from 'lodash.merge'
import { isFunction } from 'underscore';

class Filters {

  constructor ($filtersContainer, options = {}) {

    this.options = merge({
      onChange: null,
    }, options);

    this.$filtersContainer = $filtersContainer;

    this.filterItems = this.$filtersContainer[0].querySelectorAll('.filters-list-item');
    this.filterItems = Array.from(this.filterItems);

    this.activeFilter = null;
    this.filters = {};
    this.filtered = {};

    this.filterItems.forEach(item => {

      const type = $(item).data('for');
      const container = $(item);
      const toggle = $(item.querySelector('.filters-list-item-button'));

      const name = toggle.text();

      this.filters[type] = {
        name,
        container,
        toggle,
      };

      container.find('button[data-for="apply"]').on('click', () => {
        this.applyFilter(type);
      });

      container.find('button[data-for="clear"]').on('click', () => {
        this.clearFilter(type);
      });

      toggle.on('click', e => {
        this.maybeOpenFilter(type);
      });

    });

  }

  getFiltered() {
    return this.filtered;
  }

  clearFilter(type) {

    this.filtered[type] = [];
    this.filters[type].container.find('input[type="checkbox"]').prop('checked', false);
    this.filters[type].container.toggleClass('has-checked', false);

    if(isFunction(this.options.onChange)) {
      this.options.onChange(this.filtered);
    }

    this.closeFilter();

  }

  applyFilter(type) {

    this.filtered[type] = {};

    this.filters[type].container.find('input[type="checkbox"]').each((i, checkbox) => {

      let name = $(checkbox).attr('name');
      let filterIsArray = false;

      if(name.includes('[]')) {
        name = name.replace('[]', '');
        filterIsArray = true;
      }

      if(filterIsArray) {

        if($(checkbox).is(':checked')) {

          if(!this.filtered[type][name]) {
            this.filtered[type][name] = [];
          }

          this.filtered[type][name].push(checkbox.value);

        }

      } else {

        if($(checkbox).is(':checked')) {
          this.filtered[type][name] = 1;
        }

      }

    });

    this.filters[type].container.find('input[type="text"]').each((i, text) => {

      let name = $(text).attr('name');
      let filterIsArray = false;

      if(name.includes('[]')) {
        name = name.replace('[]', '');
        filterIsArray = true;
      }

      if(filterIsArray) {

        if(text.value.length > 0) {

          if(!this.filtered[type][name]) {
            this.filtered[type][name] = [];
          }

          this.filtered[type][name].push(text.value);
        }

      } else {

        if(text.value.length > 0) {
          this.filtered[type][name] = text.value;
        }

      }

    });

    const keys = Object.keys(this.filtered[type]);

    if(keys.length > 0) {
      this.filters[type].container.toggleClass('has-checked', true);
    } else {
      this.filters[type].container.toggleClass('has-checked', false);
    }

    if(isFunction(this.options.onChange)) {
      this.options.onChange(this.filtered);
    }

    this.closeFilter();

  }

  closeFilter() {

    this.filters[this.activeFilter].container.removeClass('is-active');
    this.filters[this.activeFilter].toggle.html(`
          <i class="fas fa-filter"></i> ${this.filters[this.activeFilter].name}
        `);

    this.activeFilter = false;

  }

  maybeOpenFilter(type) {

    if(!this.activeFilter) {

      // no filter, open
      this.activeFilter = type;
      this.filters[this.activeFilter].container.addClass('is-active');

      this.filters[this.activeFilter].toggle.html(`
        <i class="far fa-times"></i> ${this.filters[this.activeFilter].name}
      `);

    } else {

      if(this.activeFilter === type) {

        // filter clicked while open, close
        this.filters[this.activeFilter].container.removeClass('is-active');
        this.filters[this.activeFilter].toggle.html(`
          <i class="fas fa-filter"></i> ${this.filters[this.activeFilter].name}
        `);

        this.activeFilter = false;

      } else {

        // change filter
        this.filters[this.activeFilter].container.removeClass('is-active');
        this.filters[this.activeFilter].toggle.html(`
          <i class="fas fa-filter"></i> ${this.filters[this.activeFilter].name}
        `);

        this.activeFilter = type;
        this.filters[this.activeFilter].container.addClass('is-active');

        this.filters[this.activeFilter].toggle.html(`
          <i class="far fa-times"></i> ${this.filters[this.activeFilter].name}
        `);

      }

    }


  }

}

export default Filters;
